import { fetchBaseQueryWrapper } from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

const TAG_TYPES = {
  keyMilestones: "KeyMilestones",
} as const;

export const keyMilestonesApi = createApi({
  reducerPath: "keyMilestonesApi",
  baseQuery: fetchBaseQueryWrapper(),
  tagTypes: [TAG_TYPES.keyMilestones],
  endpoints: (build) => ({
    getKeyMilestones: build.query<string[], string>({
      query: (projectTemplatePublicId) =>
        `keyMilestones?projectTemplatePublicId=${projectTemplatePublicId}`,
      transformResponse: ({ data }: { data: string[] }) => data,
      providesTags: [TAG_TYPES.keyMilestones],
    }),
    addKeyMilestones: build.mutation<
      void,
      { id: string; milestoneTemplateIds: string[] }
    >({
      query: ({ id, milestoneTemplateIds }) => ({
        url: `keyMilestones`,
        method: "POST",
        body: { projectTemplatePublicId: id, milestoneTemplateIds },
      }),
      invalidatesTags: [TAG_TYPES.keyMilestones],
    }),
    deleteKeyMilestones: build.mutation<
      void,
      { id: string; milestoneTemplateIds: string[] }
    >({
      query: ({ id, milestoneTemplateIds }) => ({
        url: `keyMilestones`,
        method: "DELETE",
        body: { projectTemplatePublicId: id, milestoneTemplateIds },
      }),
      invalidatesTags: [TAG_TYPES.keyMilestones],
    }),
  }),
});

export const {
  useGetKeyMilestonesQuery,
  useAddKeyMilestonesMutation,
  useDeleteKeyMilestonesMutation,
} = keyMilestonesApi;
